import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../src/common/SafeIcon';

const { FiScale, FiMessageSquare, FiSlash, FiShield } = FiIcons;

export const Features: React.FC = () => {
  const features = [
    { icon: FiScale, title: "Compliance-Aware", desc: "Built by design to respect regulatory boundaries and firm policies." },
    { icon: FiSlash, title: "No Hype", desc: "No moon-talk, no price targets, no predictions. Just mechanics and facts." },
    { icon: FiMessageSquare, title: "Advisor-First Language", desc: "Frameworks focused on professional communication and client confidence." },
    { icon: FiShield, title: "Universally Useful", desc: "Valuable even if your firm restricts crypto recommendations." }
  ];
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-serif font-bold text-slate-900 mb-4">What Makes This Different</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((f, i) => (
            <div key={i} className="flex flex-col items-center text-center p-8 bg-white rounded-xl shadow-sm border border-slate-200 hover:border-brand-200 transition-colors">
              <div className="w-12 h-12 rounded-lg bg-brand-50 flex items-center justify-center mb-6">
                <SafeIcon icon={f.icon} className="w-6 h-6 text-brand-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3">{f.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};